import React from 'react';
import { toast, ToastOptions } from 'react-toastify';
import {} from 'providers/SocketioProvider/chat/actions';
import { useChatsNotifications } from 'providers/SocketioProvider/chat/selectors';
import { Box, Paper, Typography } from '@material-ui/core';
import MemberAvatar from '../MemberAvatar';
import { useHistory } from 'react-router';
import NavigationConfig from 'navigation/config';
import { Environment } from 'config';

const MessageNotification = () => {
  const chatnotifications = useChatsNotifications(['/chat/']);
  const history = useHistory();
  const message = chatnotifications?.message || null;

  const renderText = React.useCallback(
    (message: string, chatname: string, pictureid?: string) => {
      return (
        <Box alignItems={'center'} display={'flex'}>
          <MemberAvatar
            online
            src={`${Environment.API_BASE_URL}/${pictureid}`}
          />
          <Box>
            <Typography>{chatname}</Typography>
            <Typography>{message}</Typography>
          </Box>
        </Box>
      );
    },
    []
  );

  // check the path and ignore the messages
  React.useEffect(() => {
    if (message) {
      toast(
        renderText(
          message,
          chatnotifications?.senderName || 'Guest user',
          chatnotifications?.virtualpath
        ),
        {
          hideProgressBar: true,
          // type: 'info',
          position: 'bottom-right',
          // onClick: () => {
          //   history.push(
          //     NavigationConfig.chatPage({
          //       chatGuid: chatnotifications?.chatGuid ?? '',
          //     }).path
          //   );
          // },
        }
      );
    }
  }, [message, renderText]);

  return <></>;
};

export default React.memo(MessageNotification);
